export const defaultCheckboxCellContentProps = {
  align: 'center',
  width: '120px',
};
